/*
 * Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { apiPersistCache } from "hooks/use-api-persist-cache";
import { updateModel } from "./reducers/model";
import { set } from "lodash";

const allowedActions = [
    "model/addComponent",
    "model/removeComponent",
    "model/setComponents",
    "model/setFieldComponentProperties",
    "model/setFieldValueAtPath",
];

/**
 * @type {import('@reduxjs/toolkit').ThunkMiddleware<import('./reducers/model').RootState>}
 */
const apiPersistModelMiddleware = (store) => (next) => (action) => {
    
    const result = next(action);
    
    // only operate on model changes
    const allowedAction = allowedActions.includes(action.type);

    // target 
    if (allowedAction) {
        // TODO: caching the token this way might cause issues when the token expires
        const token = apiPersistCache?.token;
        let update = {};
        const payload = action?.payload;
        const path = payload?.path;
        
        // for model/setFieldValueAtPath
        if (path) {
            const state = store.getState();
            const model = state?.model?.current;
            update = structuredClone(model);
            const value = payload?.value;
            set(update, path, value);
        }
        
        store.dispatch(updateModel({
            token,
            update
        }));
    }

    return result;
};

export { apiPersistModelMiddleware };


/**
 * @typedef {import('./reducers/model/model.state').Model} Model
 */
